import { render, staticRenderFns } from "./Syllabus.vue?vue&type=template&id=90e4b05c&scoped=true&"
import script from "./Syllabus.vue?vue&type=script&lang=js&"
export * from "./Syllabus.vue?vue&type=script&lang=js&"
import style0 from "./Syllabus.vue?vue&type=style&index=0&id=90e4b05c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e4b05c",
  null
  
)

export default component.exports